module.exports = __webpack_public_path__ + "img/login-sso.cb6cc3a6.svg";